(function () {
  'use strict';

  /**
   * @ngdoc object
   *
   *
   * @description
   *
   */
  angular
    .module('crewProfile')
    .controller('HistoryController', CrewBaseHistoryController);

  function CrewBaseHistoryController($uibModalInstance, modalParams, ProfileService) {
    var vm = this;

    vm.model = {
      crewBaseAssignments : []
    };

    function getCrewBaseAssignmentData() {
      var param = {};
      param.crewProfileId = modalParams.crewProfileId;
      ProfileService.getAllCrewBaseAssignmentData(param,
        function (response) {
          vm.model.crewBaseAssignments = response;
        },
        function (error) {
          console.log('Crew base assignment data retrieval error')
        }
      );
    }

    vm.closeMe = function () {
      $uibModalInstance.close();
    };

    getCrewBaseAssignmentData();
  }
}());
